import Button from "../components/Button"
import React from "react"
import styles from "../styles/powerFive.module.scss"

function PowerFive(props) {
  return (
    <div className={styles.powerFive}>
      <div className={styles.powerFive_inner}>
        <div className={styles.powerFive_inner_txt}>
          <h2>
            You have now discovered <span className={styles.blue}>YOUR</span>{" "}
            “Power Five,” the Ethos which make you, <span className={styles.blue}>YOU</span>!
          </h2>
          <p>
            <span className={styles.blue}>What’s Next?</span> Learn how to harness
            and apply the power of YOUR Ethos to achieving your goals in life,
            health, business and beyond by choosing a package below!
          </p>
        </div>
      </div>
    </div>
  )
}

export default PowerFive
